/**
 * useLocationBySlug — fetch a single `locations` row by its slug.
 *
 * Used by the map view to recenter when a `?location=` slug is present.
 */
import { useQuery } from "@tanstack/react-query";
import { supabase, unwrapMaybe } from "@/data/client";
import { keys } from "@/data/keys";

export interface LocationLookup {
  id: string;
  lat: number | null;
  lng: number | null;
  name: string;
  type: string;
  geometry_bounds: unknown | null;
}

export function useLocationBySlug(slug: string | null | undefined) {
  return useQuery<LocationLookup | null>({
    queryKey: slug ? [...keys.locations.all, "slug", slug] : [...keys.locations.all, "slug", "__none__"],
    enabled: Boolean(slug),
    staleTime: 5 * 60_000,
    queryFn: async () => {
      const res = await supabase
        .from("locations")
        .select("id, lat, lng, name, type, geometry_bounds")
        .eq("slug", slug!)
        .maybeSingle();
      return unwrapMaybe<LocationLookup>(res as any);
    },
  });
}
